export const getInitialsFromName = (name: string, maxNumInitials: number = 2) => {
    const splitName = name.split(' ');

    return new Array(Math.min(splitName.length, maxNumInitials))
        .fill(null)
        .map((_, index) => splitName[index][0]?.toUpperCase())
        .join('');
};
